import { createFileRoute, Link } from '@tanstack/react-router'
import { Page, PageHeader, Card, SkeletonRows, EmptyState } from '@/components/rm'
import { fmtDateTime } from '@/lib/ph'
import { useThreads } from '@/lib/messages'

// Spec 006. The business's marketplace conversations. English first (business tools).
export const Route = createFileRoute('/_app/inbox')({ component: BusinessInbox })

function BusinessInbox() {
  const threads = useThreads('business')
  return (
    <Page>
      <PageHeader title="Messages" subtitle="Conversations with clients on MySerbisyo." />
      {threads.isLoading && <Card className="mt-5"><SkeletonRows /></Card>}
      {!threads.isLoading && (threads.data ?? []).length === 0 && <Card className="mt-5"><EmptyState label="No conversations yet. Clients can message you from your listing and your offers." /></Card>}
      <div className="mt-5 space-y-2">
        {(threads.data ?? []).map((th) => (
          <Link key={th.id} to="/inbox/$id" params={{ id: th.id }} className="flex items-start gap-3 rounded-[12px] border border-token-subtle bg-token-surface p-3.5 hover:border-token-strong">
            <span className="min-w-0 flex-1">
              <span className="flex items-baseline justify-between gap-2">
                <span className="truncate text-[14.5px] font-bold text-token-primary">{th.counterpart}</span>
                {th.last_message_at && <span className="flex-none text-[11.5px] text-token-muted">{fmtDateTime(th.last_message_at)}</span>}
              </span>
              {th.task_title && <span className="block truncate text-[12px] text-token-secondary">About: {th.task_title}</span>}
              <span className="mt-0.5 block truncate text-[13px] text-token-secondary">{th.last_message ?? ''}</span>
            </span>
            {th.unread > 0 && <span className="mt-1 flex h-5 min-w-5 flex-none items-center justify-center rounded-full bg-brand px-1.5 text-[11px] font-bold text-brand-fg">{th.unread}</span>}
          </Link>
        ))}
      </div>
    </Page>
  )
}
